import { useMediaQuery, useTheme } from '@mui/material'

interface UseAppProps {
  isMobile: boolean
  isDesktop: boolean
}

const useApp = (): UseAppProps => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return { isMobile, isDesktop: !isMobile }
}

export default useApp
